import React from 'react';

/**
 * ProgressBar — linear progress / completion track. Tone-coloured.
 */
export function ProgressBar({ value = 0, max = 100, tone = 'brand', showLabel = false, size = 'md', style = {}, ...rest }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  const tones = {
    brand: 'var(--brand-600)', secure: 'var(--secure-600)', warning: 'var(--warn-600)', critical: 'var(--crit-600)',
  };
  const h = size === 'sm' ? 6 : size === 'lg' ? 12 : 8;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, width: '100%', ...style }} {...rest}>
      <div style={{ width: '100%', height: h, background: 'var(--ink-100)', borderRadius: 'var(--radius-full)', overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: tones[tone] || tones.brand, borderRadius: 'var(--radius-full)', transition: 'width var(--dur-slow) var(--ease-out)' }} />
      </div>
      {showLabel && <span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>{Math.round(pct)}%</span>}
    </div>
  );
}
